import { render } from "./WizardResultsProfile.vue?vue&type=template&id=38d72c0f"
import script from "./WizardResultsProfile.vue?vue&type=script&lang=js"
export * from "./WizardResultsProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/wizard/WizardResultsProfile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "38d72c0f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('38d72c0f', __exports__)) {
    api.reload('38d72c0f', __exports__)
  }
  
  module.hot.accept("./WizardResultsProfile.vue?vue&type=template&id=38d72c0f", () => {
    api.rerender('38d72c0f', render)
  })

}


export default __exports__